export const materialColors = [
  'yellow',
  'orange',
  'red',
  'green',
  'darkgreen',
  'neutral',
  'blue',
  'darkblue',
  'cyan',
  'purple',
  'pink',
  'fuschia',
]
